if (!customElements.get('collection-custom-filter')) {
  class CollectionCustomFilter extends HTMLElement {
    constructor() {
      super();
      this.filterName = this.getAttribute('data-filter-name');
      this.container = this.querySelector('[data-custom-filter-loading-container]');

      this.container.addEventListener('click', (e) => {
        const item = e.target;
        if (item.tagName == 'LI') {
          const name = item.getAttribute('data-filter-item');
          const findFacetsItem = document.querySelector(`.facets-checkbox-input input[value="${name}"]`);
          if (findFacetsItem) {
            findFacetsItem.click();
          } else {
            console.error(`Filter: "${name}" not found.`)
          }
        }
      });
    }

    connectedCallback() { }
  }

  customElements.define('collection-custom-filter', CollectionCustomFilter);
}